<template lang="pug">
  .column.center
    .width-100.banner.text-center.column.middle(:class='{"padding-bottom": !isOptionsView}')
      h1.title-big.white.bold {{ $t('preferences.preferences') }}
    .column.m-top-5(v-if='isOptionsView')
      router-view
    .column.children(v-else)
      router-view
    activate-tutorial-modal(v-if='showActivateTutorialModal')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ActivateTutorialModal from '@/components/Modals/ActivateTutorialModal'
import { routes } from '../router'

export default {
  components: { ActivateTutorialModal },
  data() {
    return {
      routes
    }
  },
  computed: {
    ...mapState({
      showActivateTutorialModal: state => state.behavior.activateTutorialModal.show
    }),
    isOptionsView() {
      return this.$route.name === routes.preferences
    }
  },
  methods: {
    ...mapActions([
      'showElement'
    ]),
    showTutorialModal() {
      this.showElement({ element: 'activateTutorialModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/_colors.scss';
@import 'src/scss/variables/_sizes.scss';

.max-width{
  max-width: $content-size;
}

.banner{
  background-color: $blue;
  background-image: url('../../src/assets/landing/bg_footer.svg');
  background-size: 70%;
  background-position: 30%;
  height: 260px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.25);
  &.padding-bottom{
    padding-bottom: 70px;
  }
}

.children{
  width: 100%;
  max-width: 500px;
  border-radius: 10px;
  border: 0.5px solid $light-gray;
  background-color: $lightest-gray;
  margin-top: -70px;
  min-height: 520px;
  margin-bottom: 150px;
}
</style>
